import { AfterViewInit, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CtBinaryOperator, CTModelDatatableFilter } from '@ctsolution/ct-framework';
import { TaskListConfiguration } from '../../../../task/task-list/task-list.configuration';
import { EventPathParam, EventTypeEnum } from 'projects/ct-manager/src/app/_core/classes/event-path-param';

@Component({
  selector: 'ctm-work-order-task',
  templateUrl: './work-order-task.component.html',
  styleUrls: ['./work-order-task.component.scss']
})
export class WorkOrderTaskComponent implements AfterViewInit {

  taskConfiguration : TaskListConfiguration | null = null;
  @Input() isQuotation : boolean = false;

  constructor(private route : ActivatedRoute) { }

  ngAfterViewInit(): void {

    const pId = this.route.snapshot.paramMap.get("id");

    if(!pId) return;

    // ✅ FIX ExpressionChangedAfterItHasBeenCheckedError
    // Ritardiamo il setup con setTimeout per evitare che l'assegnazione di taskConfiguration
    // avvenga durante il ciclo di change detection corrente
    setTimeout(() => {
      this.setup(+pId);
    }, 0);

  }

  setup(pid : number) {

    const filters : Array<CTModelDatatableFilter> = [
      CTModelDatatableFilter.create()
        .setField("WorkOrder.Oid")
        .setValue(pid)
        .setOperatorType(CtBinaryOperator.Equal)
    ]

    this.taskConfiguration = new TaskListConfiguration(filters)

    if(this.isQuotation) {

    this.taskConfiguration.setParam(EventPathParam.create(pid,EventTypeEnum.QUOTATION));

    }else{

    this.taskConfiguration.setParam(EventPathParam.create(pid,EventTypeEnum.WORKORDER));

    }


  }

}
